module.exports = __webpack_public_path__ + "img/dc_05.3a035adc.jpg";